/**
 * Enviroment config
 */
const ENV_CONFIG = process.env;

/**
 * Api's configuration
 */
const config = {
  /**
   * Api base url
   */
  API_BASE_URL: ENV_CONFIG.VUE_APP_API_BASE_URL,
  /**
   * Admin resource base url
   */
  ADMIN_API_BASE_URL: `${ENV_CONFIG.VUE_APP_API_BASE_URL}/admin`,
};

export default Object.freeze(config);
